export const tableColumn = () => {
  return [
    { type: 'checkbox', width: 50 },
    { type: 'seq', title: '序号', width: 50 },
    {
      field: 'expenseNo',
      title: '费用编号',
      width: 120,
    },
    // {
    //   field: 'createMethod',
    //   title: '创建方式',
    //   width: 100,
    // },
    // {
    //   field: 'expenseGenerationDate',
    //   title: '费用生成日期',
    //   width: 120,
    // },
    // {
    //   field: 'settlementBusinessType',
    //   title: '业务类别',
    //   width: 100,
    // },
    // {
    //   field: 'companyName',
    //   title: '公司名称',
    //   width: 120,
    // },
    // {
    //   field: 'departmentName',
    //   title: '部门名称',
    //   width: 180,
    // },
    // {
    //   field: 'supplierName',
    //   title: '客户名称',
    //   width: 120,
    // },
    // {
    //   field: 'contractNo',
    //   title: '合同编号',
    //   width: 120,
    // },
    // {
    //   field: 'receivableAccountPeriod',
    //   title: '应收账期',
    //   width: 180,
    // },
    {
      field: 'expenseTypeName',
      title: '费用类型',
      width: 180,
    },
    {
      field: 'originalPrice',
      title: '结算单价(含税)',
      width: 180,
    },

    {
      field: 'settlementQuantity',
      title: '结算数量',
      width: 120,
    },
    {
      field: 'unitName',
      title: '计量单位',
      width: 120,
    },
    {
      field: 'originalAmount',
      title: '原币结算金额(含税)',
      width: 180,
    },

    {
      field: 'currencyName',
      title: '币种',
      width: 120,
    },
    {
      field: 'exchangeRate',
      title: '汇率',
      width: 120,
    },
    {
      field: 'domesticAmount',
      title: '本币结算金额(含税)',
      width: 180,
    },
    {
      field: 'periodDateFrom',
      title: '业务结算日期从',
      width: 180,
    },
    {
      field: 'periodDateUntil',
      title: '业务结算日期至',
      width: 180,
    },
    {
      field: 'businessDocCode',
      title: '业务单据编码',
      width: 120,
    },
    {
      field: 'goodsCategoryName',
      title: '货物品类',
      width: 120,
    },
  ];
};
